var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: { id: "dashboard" },
    },
    [
      _c(
        "el-row",
        {
          staticStyle: { width: "100%" },
          attrs: { gutter: 10, type: "flex", justify: "space-between" },
        },
        [
          _c(
            "el-button",
            {
              attrs: { link: "", type: "primary", size: "small" },
              on: { click: _vm.addRow },
            },
            [_vm._v("Add new")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            stripe: "",
            "default-sort": { prop: "order_num", order: "ascending" },
          },
        },
        [
          _c("el-table-column", {
            attrs: { fixed: "", prop: "path", label: "Path", "min-width": 20 },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      attrs: {
                        disabled: !scope.row.edit,
                        placeholder:
                          "ex:: https://awardapplication.com/image.jpg",
                      },
                      model: {
                        value: scope.row.path,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "path", $$v)
                        },
                        expression: "scope.row.path",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "order_num", label: "Order", "min-width": 4 },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "Select",
                          size: "small",
                          disabled: !scope.row.edit,
                        },
                        model: {
                          value: scope.row.order_num,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "order_num", $$v)
                          },
                          expression: "scope.row.order_num",
                        },
                      },
                      _vm._l(_vm.order_arr, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.value, value: item.value },
                        })
                      }),
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "desc", label: "Description", "min-width": 60 },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-input", {
                      staticClass: "desc",
                      attrs: {
                        type: "textarea",
                        autosize: "",
                        placeholder: "ex:: Closing Deadlines for Award",
                        disabled: !scope.row.edit,
                      },
                      model: {
                        value: scope.row.desc,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "desc", $$v)
                        },
                        expression: "scope.row.desc",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "color", label: "Color", "min-width": 4 },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-color-picker", {
                      attrs: { disabled: !scope.row.edit },
                      model: {
                        value: scope.row.color,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "color", $$v)
                        },
                        expression: "scope.row.color",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { fixed: "right", label: "Operations", "min-width": 12 },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row, $index }) {
                  return [
                    row.edit
                      ? [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                link: "",
                                type: "success",
                                size: "small",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.saveRow(row, $index)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        Save\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { link: "", type: "info", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.cancelEdit(row, $index)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        Cancel\n                    "
                              ),
                            ]
                          ),
                        ]
                      : [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                link: "",
                                type: "primary",
                                size: "small",
                              },
                              on: {
                                click: function ($event) {
                                  row.edit = true
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        Edit\n                    "
                              ),
                            ]
                          ),
                        ],
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { link: "", type: "danger", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteRow(row, $index)
                          },
                        },
                      },
                      [_vm._v("\n                    Delete\n                ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }